import type { MessageProps } from 'components/Dialogue';
import dayjs, { Dayjs } from 'lib/dayjs';
import type { UIMessages } from './useChatView';

/**
 * 接口未开放发送引用消息，乐聊端引用文本消息通过字符串特殊处理,
 */
export function injectQuote(raw: Conversation.Message) {
  const { quotedMsgId, quotedTextContent } = raw;
  if (quotedMsgId && quotedTextContent?.text) {
    /* eslint-disable */
    raw.quotedMsg = {
      msgId: quotedMsgId,
      messageType: 'TEXT',
      textContent: {
        text: quotedTextContent.text,
        originalText: quotedTextContent.text,
      },
    } as Conversation.QuotedMessage;
  }
}

export const getMetaFromSender = (sender: UIMessages['sender']) => {
  const isBuyerMessage = sender === 'buyer';
  const isRobotMessage = sender === 'robot';
  const isSellerMessage = sender === 'seller';
  const layout: MessageProps['layout'] = isBuyerMessage ? 'left' : 'right';
  const color =
    layout === 'right' ? 'var(--fett-chat-bubble-agent)' : 'var(--fett-chat-bubble-customer)';

  return {
    isBuyerMessage,
    isRobotMessage,
    isSellerMessage,
    layout,
    color,
  };
};

export const timeFormatter = (time: number | Dayjs) => {
  const day = dayjs(time);
  const isSameYear = day.isSame(dayjs(), 'years');
  return day.format(isSameYear ? 'MM-DD HH:mm' : 'YYYY-MM-DD HH:mm');
};

export const isValidConversationId = (conversationId?: string) => {
  return conversationId && conversationId !== '0';
};

const JOLECT_AI_GUIDE_FINAL_RESPONSE_EVENT = 'final-response';

/** 从 Jolect AI 引导消息的 events 中解析最终回复的 markdown 文本 */
export const getJolectAiGuideMarkdown = (content?: Conversation.MsgJlAiGuide) => {
  const events = content?.events;
  if (!events?.length) {
    return undefined;
  }

  for (let index = events.length - 1; index >= 0; index -= 1) {
    const event = events[index];
    if (event.event !== JOLECT_AI_GUIDE_FINAL_RESPONSE_EVENT) {
      continue;
    }

    try {
      const data = JSON.parse(event.data) as { message?: unknown };
      if (typeof data.message === 'string') {
        return data.message;
      }
    } catch {
      continue;
    }
  }

  return undefined;
};
